import LeadCardEvent from './LeadCardEvent';
import type { LeadCardHistoryProps } from '../types';

const LeadCardHistory = ({ lead, events, fetchLead, showLockButton = true }: LeadCardHistoryProps) => {
    return (
        <div className="lead-events-list">
            {events &&
                events.map((event) => (
                    <LeadCardEvent
                        showLockButton={showLockButton}
                        fetchLead={fetchLead}
                        key={`event-${event.eventCreated}`}
                        event={event}
                        lead={lead}
                    />
                ))}
        </div>
    );
};

export default LeadCardHistory;
